'use client';

import { useEffect } from 'react';

export default function SiteHeaderScroll() {
  useEffect(() => {
    if (CSS.supports('animation-timeline: scroll()')) return;

    const header = document.querySelector('header.SiteHeader');
    if (!header) return;

    const onScroll = () => {
      header.classList.toggle('SiteHeader--scrolled', window.scrollY > 50);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return null;
}
